import { render, staticRenderFns } from "./VesselDocuments.vue?vue&type=template&id=1f29ed1c&scoped=true"
import script from "./VesselDocuments.vue?vue&type=script&lang=ts"
export * from "./VesselDocuments.vue?vue&type=script&lang=ts"
import style0 from "./VesselDocuments.vue?vue&type=style&index=0&id=1f29ed1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f29ed1c",
  null
  
)

export default component.exports